
<div class="main-page-content">
  <div class="main-page-content-block">

    <h1 class="content-heading-font">{{ currentItem?.BusinessName ||'Client' }} Users</h1>


    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result ?? []"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords ?? 0"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 [multiSortMeta]="[{field: 'UserName', order: 1}]"
                 sortMode="multiple">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">#<p-sortIcon field="ID"></p-sortIcon></th>
              <th pSortableColumn="UserName" class="text-start">
                User Name
                <p-sortIcon field="UserName"></p-sortIcon>
                <p-columnFilter type="text" field="UserName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="FirstName" class="text-star d-none d-lg-table-cell">
                First Name <p-sortIcon field="FirstName"></p-sortIcon>
                <p-columnFilter type="text" field="FirstName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="LastName" class="text-star d-none d-xl-table-cell">
                Last Name <p-sortIcon field="LastName"></p-sortIcon>
                <p-columnFilter type="text" field="LastName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Email" class="text-star d-none d-xl-table-cell">
                Email <p-sortIcon field="Email"></p-sortIcon>
                <p-columnFilter type="text" field="Email" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Inactive" class="text-start d-none d-lg-table-cell">
                Status <p-sortIcon field="Inactive"></p-sortIcon>
                <p-columnFilter type="boolean" field="Inactive" matchMode="equals" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: null },{ name: 'Active', value: false },{ name: 'Inactive', value: true }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block text-">
                  <a class="btn btn-sm btn-secondary me-1  " (click)="onRowImpersonate(item)" title="Impersonate Client">
                    <i class="pi pi-key"></i>
                  </a>
                  <a class="btn btn-sm btn-primary me-1" [routerLink]="['/client', client_id, 'User', item.ID]" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>

              <td>
               {{ item.UserName }}
              </td>
              <td class=" d-none d-lg-table-cell">{{ item.FirstName }}</td>
              <td class=" d-none d-xl-table-cell">{{ item.LastName }}</td>
              <td class=" d-none d-xl-table-cell">{{ item.Email }}</td>
              <td class=" d-none d-lg-table-cell fw-bold">
                <div [ngClass]="{'text-danger': item.Inactive, 'text-success': !item.Inactive}">
                  {{ item.Inactive ? 'Inactive' : item.Hidden ? 'Hidden':'Active' }}
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="addItem(dt1)" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No items found.</td>
            </tr>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>

  <!--
  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">
      <img [src]="getClientLogo(currentItem)" class="bussinesLogo d-lg-inline-block" *ngIf="currentItem.Active" />
      {{currentItem.FirstName || currentItem.UserName }}
    </h1>


    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="UserName">UserName</label>
          <input class="form-control" name="UserName" formControlName="UserName" autocomplete="off" placeholder="UserName" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="FirstName">First Name</label>
          <input class="form-control" name="FirstName" formControlName="FirstName" autocomplete="off" placeholder="First Name" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="LastName">Last Name</label>
          <input class="form-control" name="LastName" formControlName="LastName" autocomplete="off" placeholder="Last Name Name" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Email">Email</label>
          <input class="form-control" name="Email" formControlName="Email" autocomplete="off" placeholder="Email" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="PhoneNumber">Phone Number</label>
          <input class="form-control" name="PhoneNumber" formControlName="PhoneNumber" autocomplete="off" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Active">Active </label>
          <select class="form-control" name="Active" formControlName="Active">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
        </div>
      </div>
    </form>
  </div>-->
</div>



<p-dialog header="Login on {{clientLoginItem?.UserName}}" [modal]="true" [(visible)]="clientLoginVisible">
  <div class="row" *ngIf="!clientLoginUrl">
    <div class="col mb-3">
      <label for="client_userID">Would you like to impersonate Client User {{currentItem?.SiteName}} - {{clientLoginItem?.FirstName }} {{clientLoginItem?.LastName}}?</label>
      
    </div>
  </div>
  <div class="row" *ngIf="!clientLoginUrl">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnClientLogin" [class.button-loading]="loading" (click)="clientLogin()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnClientLoginCancel" [class.button-loading]="loading" (click)="clientLoginVisible=false">Cancel</button>
    </div>
  </div>
  <div class="row" *ngIf="clientLoginUrl">
    <div class="col mb-3 text-body-emphasis">
      <a href="{{clientLoginUrl}}" target="{{clientLoginItem?.UserName}}">https://{{clientLoginItem?.UserName?.toLowerCase()}}.{{this.baseDomain}}</a>
    </div>
  </div>
</p-dialog>
  
